/**
 * Microsoft Clarity Analytics Integration
 * Optimized for async loading
 * Load with: <script src="clarity-analytics.js" async defer></script>
 */

(function () {
  "use strict";

  // Early exit if already loaded
  if (window.clarityLoaded) return;
  window.clarityLoaded = true;

  try {
    (function (c, l, a, r, i, t, y) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r);
      t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", "g10pz4rfks");
  } catch (error) {
    console.warn("Clarity Analytics failed to initialize:", error);
  }
})();
